import { Layout } from 'antd';
import sc from 'styled-components';
import React, { PureComponent } from 'react';
import _ from 'lodash';
import { withSize } from 'react-sizeme';
import { WHITE } from './styleConstants';
import Scroller from './Scroller';

const ResponsiveContent = sc(Layout.Content)`
background-color: ${WHITE};
overflow: hidden;
.content {
  padding: 0 !important;
}
`;

export const ContentSizeContext = React.createContext({ width: 1000, height: 1000 });

class SizeBroadcaster extends PureComponent {
  render() {
    const size = _.get(
      this, 'props.size',
      { width: 1000, height: 1000 },
    );
    return (
      <ResponsiveContent id="content-frame" className="content background">
        <ContentSizeContext.Provider value={size}>
          <Scroller>{this.props.children}</Scroller>
        </ContentSizeContext.Provider>
      </ResponsiveContent>
    );
  }
}

export default withSize({ refreshRate: 100, refreshMode: 'throttle', monitorHeight: true })(SizeBroadcaster);
